import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import { useEffect, FormEvent } from 'react';
import { useApplication } from '../../../model/context/applicationContext';
import SearchIcon from '@mui/icons-material/Search';

interface ApplicationNumberInputProps {
  inputValue: string | undefined;
  setInputValue: (appNr: string | undefined) => void;
}

export const ApplicationNumberInput = (props: ApplicationNumberInputProps) => {
  const { inputValue, setInputValue } = props;

  const { applicationSource, applicationNumber, setApplication } = useApplication();

  useEffect(() => {
    if (applicationSource === 'Dploy') {
      setInputValue(applicationNumber);
    }
  }, [applicationNumber]);

  return (
    <form
      onSubmit={async (submitEvent: FormEvent<HTMLFormElement>) => {
        submitEvent.preventDefault();
        if (inputValue?.length === 0) return;
        await setApplication(inputValue || '', 'Dploy');
      }}>
      <FormControl variant="outlined" disabled={false} sx={{ mt: 1 }}>
        <InputLabel>Application number</InputLabel>
        <OutlinedInput
          label="Application number"
          value={inputValue}
          onChange={(e) => setInputValue(e.currentTarget.value)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton type="submit" edge="end" disabled={false}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </form>
  );
};
